import portalClient from '@/services/PortalClient'

export default {
  fetchSubscriptionPrice () {
    return portalClient.sendRequest(
      'GET',
      'admin/api/v1/subscription/price'
    )
  },
  saveSubscriptionPrice (data) {
    return portalClient.sendRequest(
      'POST',
      'admin/api/v1/subscription/price',
      data
    )
  },
  fetchSubscriptionDiscounts () {
    return portalClient.sendRequest(
      'GET',
      'admin/api/v1/subscription/discount'
    )
  },
  addSubscriptionDiscount (data) {
    return portalClient.sendRequest(
      'POST',
      'admin/api/v1/subscription/discount',
      data
    )
  },
  deleteSubscriptionDiscounts (id) {
    return portalClient.sendRequest(
      'DELETE',
      `admin/api/v1/subscription/discount/${id}`
    )
  }
}
